<template>
  <v-dialog
    :value="dialog"
    @input="$emit('update:dialog', $event)"
    max-width="1000"
  >
    <v-card tile>
      <v-card-title class="headline">
        Detalles del Turno <v-spacer></v-spacer>
        <v-btn icon @click="$emit('update:dialog', false)">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="6" class="text-right">
            <v-btn
              color="primary"
              :disabled="selectedFiles.length === 0"
              @click="descargarArchivosSeleccionados"
            >
              <v-icon left>fas fa-download</v-icon>
              Descargar seleccionados ({{ selectedFiles.length }})
            </v-btn>
          </v-col>
        </v-row>
        <v-stepper v-model="step" non-linear>
          <v-stepper-header>
            <v-stepper-step editable step="1"> Inicio de Turno </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step editable step="2"> Fin de Turno </v-stepper-step>
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-data-table
                v-model="selectedFiles"
                :items="itemsPorCarpeta.INICIO"
                :headers="headers_archivos"
                :loading="loading"
                loading-text="Cargando archivos..."
                fixed-header
                class="elevation-1"
                item-key="id"
                height="400px"
                show-select
              >
                <!-- FECHA -->
                <template v-slot:[`item.lastModifiedDateTime`]="{ item }">
                  <span> {{ formatoFecha(item.lastModifiedDateTime) }} </span>
                </template>
                <!-- VISTA PREVIA -->
                <template v-slot:[`item.action_view`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="blue"
                        @click="vistaPrevia(item.id)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon> fa-regular fa-folder-open </v-icon>
                      </v-btn>
                    </template>
                    <span>Ver archivo</span>
                  </v-tooltip>
                </template>
                <!-- DESCARGAR -->
                <template v-slot:[`item.action_download`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="primary"
                        @click="descargarArchivo(item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon> fas fa-cloud-download-alt </v-icon>
                      </v-btn>
                    </template>
                    <span>Descargar</span>
                  </v-tooltip>
                </template>
                <template v-slot:no-data>
                  <div class="py-4">No se encontraron archivos de inicio.</div>
                </template>
              </v-data-table>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-data-table
                v-model="selectedFiles"
                :items="itemsPorCarpeta.FIN"
                :headers="headers_archivos"
                :loading="loading"
                loading-text="Cargando archivos..."
                fixed-header
                class="elevation-1"
                item-key="id"
                height="400px"
                show-select
              >
                <!-- FECHA -->
                <template v-slot:[`item.lastModifiedDateTime`]="{ item }">
                  <span> {{ formatoFecha(item.lastModifiedDateTime) }} </span>
                </template>
                <!-- VISTA PREVIA -->
                <template v-slot:[`item.action_view`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="blue"
                        @click="vistaPrevia(item.id)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon> fa-regular fa-folder-open </v-icon>
                      </v-btn>
                    </template>
                    <span>Ver archivo</span>
                  </v-tooltip>
                </template>
                <!-- DESCARGAR -->
                <template v-slot:[`item.action_download`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="primary"
                        @click="descargarArchivo(item)"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon> fas fa-cloud-download-alt </v-icon>
                      </v-btn>
                    </template>
                    <span>Descargar</span>
                  </v-tooltip>
                </template>
                <template v-slot:no-data>
                  <div class="py-4">No se encontraron archivos de fin.</div>
                </template>
              </v-data-table>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <v-row>
          <v-col>
            <v-card outlined>
              <v-card-title class="text-h6">
                Check List
              </v-card-title>

              <v-card-text>
                <!-- EQUIPAMIENTO -->
                <v-card outlined class="mb-4">
                  <v-card-title class="text-subtitle-1 font-weight-bold">
                    Equipamiento
                  </v-card-title>

                  <v-card-text>
                    <v-row class="pa-0 ma-0">
                      <v-col
                        v-for="item in checklist.equipamiento"
                        :key="item.id"
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-checkbox
                          v-model="item.checked"
                          :label="item.nombre"
                          hide-details
                          dense
                          readonly
                          class="mt-0"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <!-- LUCES -->
                <v-card outlined class="mb-4">
                  <v-card-title class="text-subtitle-1 font-weight-bold">
                    Luces
                  </v-card-title>

                  <v-card-text>
                    <v-row class="pa-0 ma-0">
                      <v-col
                        class="pa-0 ma-0"
                        v-for="item in checklist.luces"
                        :key="item.id"
                        cols="12"
                        sm="6"
                        md="3"
                      >
                        <v-checkbox
                          v-model="item.checked"
                          :label="item.nombre"
                          hide-details
                          dense
                          readonly
                          class="mt-0"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <!-- AUDIO -->
                <v-card outlined>
                  <v-card-title class="text-subtitle-1 font-weight-bold">
                    Audio
                  </v-card-title>

                  <v-card-text>
                    <v-row class="pa-0 ma-0">
                      <v-col
                        class="pa-0 ma-0"
                        v-for="item in checklist.audio"
                        :key="item.id"
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-checkbox
                          v-model="item.checked"
                          :label="item.nombre"
                          hide-details
                          readonly
                          dense
                          class="mt-0"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-card-text>
              <v-card-text>
                <v-textarea
                  v-model="checklist.observaciones"
                  outlined
                  dense
                  readonly
                  hint="Registre cualquier detalle, anomalía o elemento no contemplado en el checklist."
                  label="Observaciones (opcional)"
                ></v-textarea>
              </v-card-text>
              <v-card-text>
                <v-textarea
                  v-model="observacionEncargado"
                  outlined
                  dense
                  :readonly="$store.state.usuario.rol != 'Team Leader Grua'"
                  hint="Detalles de revisión de encargado..."
                  label="Observaciones Encargado"
                ></v-textarea>
                <v-btn
                  v-if="$store.state.usuario.rol == 'Team Leader Grua'"
                  @click="actualizarObservacion"
                  >Guardar</v-btn
                >
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog_preview" max-width="600">
      <v-card tile>
        <v-card-title>
          Vista previa <v-spacer></v-spacer>
          <v-btn icon @click="dialog_preview = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text> <v-img :src="url_preview" contain></v-img> </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_progress_linear" width="300" persistent>
      <v-card>
        <v-progress-linear
          indeterminate
          height="6"
          color="blue"
          stream
          rounded
          striped
        ></v-progress-linear>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :color="snackbar_color" bottom>
      {{ mensaje_snackbar }}
    </v-snackbar>
  </v-dialog>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { saveAs } from "file-saver";
import JSZip from "jszip";

export default {
  name: "AdminArchivosHistorialGrua",
  props: {
    dialog: { type: Boolean, default: false },
    rutaBase: { type: String, default: "" },
    detalles: { type: Array, default: () => [] },
    historialOperadorId: { type: Number, required: true },
    observacion: { type: String, default: "" },
  },
  data() {
    return {
      checklist: {
        equipamiento: [
          { id: 1, nombre: "Fajas", checked: false },
          { id: 2, nombre: "Llantas", checked: false },
          { id: 3, nombre: "Extintor", checked: false },
          { id: 4, nombre: "Llanta de repuesto", checked: false },
          { id: 5, nombre: "Mica", checked: false },
          { id: 6, nombre: "Llave de rueda", checked: false },
          { id: 7, nombre: "Cono", checked: false },
          { id: 8, nombre: "Cinchas de amarre", checked: false },
          { id: 9, nombre: "Cadenas", checked: false },
        ],
        luces: [
          { id: 11, nombre: "Frontales", checked: false },
          { id: 12, nombre: "Traseras", checked: false },
          { id: 13, nombre: "Vías", checked: false },
          { id: 14, nombre: "Stop", checked: false },
        ],
        audio: [
          { id: 15, nombre: "CD Player", checked: false },
          { id: 16, nombre: "Bocinas extras", checked: false },
        ],
        observaciones: "",
      },
      selectedFiles: [],
      step: 1,
      loading: false,
      snackbar: false,
      snackbar_color: "primary",
      mensaje_snackbar: "",
      dialog_preview: false,
      observacionEncargado: "",
      url_preview: "",
      dialog_progress_linear: false,
      itemsPorCarpeta: { INICIO: [], FIN: [] },
      rutasCarpetas: ["INICIO", "FIN"],
      headers_archivos: [
        { text: "Nombre", value: "name" },
        {
          text: "Categoría",
          value: "categoria",
          align: "center",
        },
        { text: "Fecha última modificación", value: "lastModifiedDateTime" },
        {
          text: "Ver archivo",
          value: "action_view",
          align: "center",
          sortable: false,
        },
        {
          text: "Descargar",
          value: "action_download",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  created() {
    this.limpiarArchivos();
    this.getArchivosPorCarpeta();
  },
  watch: {
    dialog(value) {
      if (value) {
        this.step = 1;
        this.actualizarChecklist(this.step);
        if (this.rutaBase) {
          this.limpiarArchivos();
          this.getArchivosPorCarpeta();
        }
      }
    },
    observacion: {
      handler(value) {
        this.observacionEncargado = value || "";
      },
      immediate: true,
    },
    step(val) {
      this.actualizarChecklist(val);
    },
    detalles: {
      handler(nuevoDetalles) {
        if (!nuevoDetalles || nuevoDetalles.length === 0) return;
        this.actualizarChecklist(this.step);
      },
      immediate: true,
      deep: true,
    },
    rutaBase(value) {
      if (this.dialog && value) {
        this.limpiarArchivos();
        this.getArchivosPorCarpeta();
      }
    },
  },
  methods: {
    async actualizarObservacion() {
      if (this.$store.state.usuario.rol != "Team Leader Grua") return;

      const header = {
        Authorization: "Bearer " + this.$store.state.token,
      };

      const configuracion = {
        headers: header,
      };

      try {
        await axios.put(
          `/api/HistorialOperadoresGrua/ObservacionEncargado/${this.historialOperadorId}`,
          {
            observacionEncargado: this.observacionEncargado,
          },
          configuracion,
        );

        this.snackbar = true;
        this.snackbar_color = "primary";

        this.mensaje_snackbar = "Observación Guardada Correctamente!";

        this.$emit("actualizar-listado");
      } catch (error) {
        console.error(error);
        this.snackbar = true;
        this.snackbar_color = "error";

        this.mensaje_snackbar = "No se pudo actualizar la observación...";
      }
    },
    actualizarChecklist(step) {
      if (!this.detalles || this.detalles.length == 0) return;

      const detalle = this.detalles.find((d) =>
        step == 1 ? d.inicioTurno == true : d.inicioTurno == false,
      );

      if (!detalle) {
        console.warn(`No se encontró detalle para step ${step}`);
        return;
      }

      this.checklist.equipamiento[0].checked = detalle.fajas;
      this.checklist.equipamiento[1].checked = detalle.llantas;
      this.checklist.equipamiento[2].checked = detalle.extintor;
      this.checklist.equipamiento[3].checked = detalle.llantaRepuesto;
      this.checklist.equipamiento[4].checked = detalle.mica;
      this.checklist.equipamiento[5].checked = detalle.llaveRueda;
      this.checklist.equipamiento[6].checked = detalle.cono;
      this.checklist.equipamiento[7].checked = detalle.cinchasAmarre;
      this.checklist.equipamiento[8].checked = detalle.cadenas;

      this.checklist.luces[0].checked = detalle.lucesFrontales;
      this.checklist.luces[1].checked = detalle.lucesTraseras;
      this.checklist.luces[2].checked = detalle.lucesVias;
      this.checklist.luces[3].checked = detalle.lucesStop;

      this.checklist.audio[0].checked = detalle.cdPlayer;
      this.checklist.audio[1].checked = detalle.bocinasExtras;

      this.checklist.observaciones = detalle.observaciones || "";
    },
    async descargarArchivosSeleccionados() {
      if (!this.selectedFiles.length) return;

      this.dialog_progress_linear = true;

      try {
        const zip = new JSZip();

        const downloadPromises = this.selectedFiles.map(async (file) => {
          try {
            const response = await axios.get(
              `api/OneDrive/DescargarArchivo/${file.id}`,
              {
                responseType: "blob",
              },
            );

            const carpetaTurno = file.tipoTurno;
            const categoria = file.categoria;

            zip.file(
              `${carpetaTurno}/${categoria}/${file.name}`,
              response.data,
            );
          } catch (error) {
            this.snackbar = true;
            this.snackbar_color = "error";

            this.mensaje_snackbar = `Error descargando ${file.name}`;

            console.error(`Error descargando ${file.name}:`, error);
          }
        });

        await Promise.all(downloadPromises);

        const blob = await zip.generateAsync({
          type: "blob",
        });

        saveAs(blob, "Archivos_Turno.zip");
      } catch (error) {
        this.snackbar = true;
        this.snackbar_color = "error";
        this.mensaje_snackbar = "Error general al crear el ZIP";

        console.error("Error general al crear el ZIP:", error);
      } finally {
        this.dialog_progress_linear = false;
      }
    },
    async getArchivosPorCarpeta() {
      if (!this.rutaBase) return;

      this.loading = true;

      try {
        const rutaPadre = this.rutaBase.substring(
          0,
          this.rutaBase.lastIndexOf("/"),
        );

        for (const tipoTurno of this.rutasCarpetas) {
          const rutaTurno = `${rutaPadre}/${tipoTurno}`;

          try {
            const responseCarpetas = await axios.get(
              "api/OneDrive?ruta=" + rutaTurno,
            );

            const carpetas = responseCarpetas.data.value || [];

            const archivos = [];

            for (const carpeta of carpetas) {
              if (!carpeta.folder) continue;

              const rutaCategoria = `${rutaTurno}/${carpeta.name}`;

              try {
                const responseArchivos = await axios.get(
                  "api/OneDrive?ruta=" + rutaCategoria,
                );

                const archivosCategoria = responseArchivos.data.value || [];

                archivosCategoria.forEach((archivo) => {
                  if (!archivo.file) return;

                  archivos.push({
                    ...archivo,
                    tipoTurno: tipoTurno,
                    categoria: carpeta.name,
                  });
                });
              } catch (error) {
                console.error(
                  `Error obteniendo archivos de ${rutaCategoria}:`,
                  error,
                );
              }
            }

            this.itemsPorCarpeta[tipoTurno] = archivos;
          } catch (error) {
            console.error(`No se encontraron carpetas en ${rutaTurno}:`, error);

            this.itemsPorCarpeta[tipoTurno] = [];
          }
        }
      } catch (error) {
        console.error("Error obteniendo las rutas de archivos:", error);

        this.snackbar = true;
        this.snackbar_color = "error";
        this.mensaje_snackbar = "Error obteniendo los archivos";
      } finally {
        this.loading = false;
      }
    },
    async vistaPrevia(item) {
      this.dialog_progress_linear = true;
      try {
        const response = await axios.get(`api/OneDrive/VistaPrevia/${item}`);
        if (
          response.data &&
          response.data.value &&
          response.data.value.length > 0
        ) {
          this.url_preview = response.data.value[0].large.url;
          this.dialog_preview = true;
        } else {
          this.snackbar = true;
          this.snackbar_color = "error";
          this.mensaje_snackbar = "No se encontró una vista previa";
        }
      } catch (error) {
        console.error("Error obteniendo vista previa:", error);
        this.snackbar = true;
        this.snackbar_color = "error";
        this.mensaje_snackbar = "No se encontró una vista previa";
      } finally {
        this.dialog_progress_linear = false;
      }
    },
    async descargarArchivo(file) {
      this.dialog_progress_linear = true;
      try {
        const response = await axios.get(
          `api/OneDrive/DescargarArchivo/${file.id}`,
          {
            responseType: "blob",
          },
        );
        saveAs(response.data, file.name);
      } catch (error) {
        console.error(`Error descargando ${file.name}:`, error);
        this.snackbar = true;
        this.snackbar_color = "error";
        this.mensaje_snackbar = `Error descargando ${file.name}`;
      } finally {
        this.dialog_progress_linear = false;
      }
    },
    limpiarArchivos() {
      this.itemsPorCarpeta = { INICIO: [], FIN: [] };
      this.step = 1;
      this.dialog_preview = false;
      this.url_preview = "";
    },
    formatoFecha(fecha) {
      if (!fecha) return "";
      return moment(fecha).format("YYYY-MM-DD HH:mm:ss");
    },
  },
};
</script>
